/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_C3Inputs */

const en_guide_large_json_files_c3 = /** @type {(inputs: Guide_Large_Json_Files_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The point where a browser tool is the wrong tool`)
};

const ko_guide_large_json_files_c3 = /** @type {(inputs: Guide_Large_Json_Files_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저 도구가 틀린 선택이 되는 지점`)
};

const ja_guide_large_json_files_c3 = /** @type {(inputs: Guide_Large_Json_Files_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザツールが誤った選択になる地点`)
};

/**
* | output |
* | --- |
* | "The point where a browser tool is the wrong tool" |
*
* @param {Guide_Large_Json_Files_C3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_c3 = /** @type {((inputs?: Guide_Large_Json_Files_C3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_C3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_c3(inputs)
	if (locale === "ko") return ko_guide_large_json_files_c3(inputs)
	return ja_guide_large_json_files_c3(inputs)
});